export default function Logout() {
  const ssoURL = process.env.REACT_APP_SSO_LOGOUT_URL;
  window.location.href = ssoURL ?? '';
  return null;
}
